import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import { mapState } from 'vuex'
import NavTop from './components/NavTop'
import NavBottom from './components/NavBottom'
import NavMobile from './components/NavMobile'
import ColorsSelect from './components/ColorsSelect'
import Phrase from './components/Phrase'
import Graphic from './components/Graphic'
import Pricing from './components/Pricing'
import OrderRow from './components/OrderRow'
import BandPreview from './components/BandPreview'
import AddToCart from './components/AddToCart'
import PrevStep from './components/PrevStep'
import NextStep from './components/NextStep'
import StepsBar from './components/StepsBar'
import VStepperStepLink from './components/VStepperStepLink'
import ShareLink from './components/ShareLink'
import { Modal, Tooltip, Popover } from 'bootstrap-vue/es/components'
import InfiniteLoading from 'vue-infinite-loading'
import Vue2Filters from 'vue2-filters'
import { sync } from 'vuex-router-sync'
import FixedPreview from './utils/fixedpreview'
import _get from 'lodash/get'
import VueCookie from 'vue-cookie'
import VueScrollTo from 'vue-scrollto'
import UUID from 'vue-uuid'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPlusCircle, faTimesCircle, faAngleLeft, faAngleDown, faCheckCircle, faExclamationTriangle, faFont, faStream, faImages } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VeeValidate from 'vee-validate'
import * as Sentry from "@sentry/browser";
import { Vue as VueIntegration } from "@sentry/integrations";

Sentry.init({
  dsn: "https://100339913d9d40d4bc299d23d2b9ba56@sentry.io/1193290",
  environment: window.RB && window.RB.development ? "development" : "production",
  integrations: [new VueIntegration({ Vue, attachProps: true })],
  tracesSampleRate: 0.1,
  beforeSend: function(event, hint) {
    // Filter out common noise and known issues
    var error = hint.originalException;
    var message = event.message || (error && error.message) || '';
    var filename = event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames && event.exception.values[0].stacktrace.frames[0] && event.exception.values[0].stacktrace.frames[0].filename || '';
    
    // Ignore common browser extension and plugin errors
    var ignoreMessages = [
      'top.GLOBALS',
      'originalCreateNotification',
      'canvas.contentDocument',
      'MyApp_RemoveAllHighlights',
      'Can\'t find variable: ZiteReader',
      'jigsaw is not defined',
      'ComboSearch is not defined',
      'atomicFindClose',
      'fb_xd_fragment',
      'bmi_SafeAddOnload',
      'EBCallBackMessageReceived',
      'conduitPage'
    ];
    
    var ignoreUrls = [
      /graph\.facebook\.com/i,
      /connect\.facebook\.net\/en_US\/all\.js/i,
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      /extensions\//i,
      /^chrome:\/\//i,
      /127\.0\.0\.1:4001\/isrunning/i,
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
      /tt\.epicplay\.com/i,
      /loading\.retry\.widdit\.com/i,
      /ct\.pinterest\.com/i,
      /s\.pinimg\.com/i
    ];
    
    // Check message filters
    for (var i = 0; i < ignoreMessages.length; i++) {
      if (message.indexOf(ignoreMessages[i]) !== -1) {
        return null; // Don't send to Sentry
      }
    }
    
    // Check URL filters
    for (var i = 0; i < ignoreUrls.length; i++) {
      if (ignoreUrls[i].test(filename)) {
        return null; // Don't send to Sentry
      }
    }
    
    // Sanitize sensitive data
    if (event.user && event.user.email) {
      event.user.email = event.user.email.replace(/(..).*@/, '$1***@');
    }
    
    // Remove sensitive form data from request data
    if (event.request && event.request.data) {
      var sensitiveFields = ['password', 'credit_card', 'ssn', 'social_security'];
      for (var field in event.request.data) {
        for (var j = 0; j < sensitiveFields.length; j++) {
          if (field.toLowerCase().indexOf(sensitiveFields[j]) !== -1) {
            delete event.request.data[field];
          }
        }
      }
    }
    
    return event; // Send to Sentry
  }
});

Vue.config.productionTip = false

const veeConfig = {
  inject: false
}
Vue.use(VeeValidate, veeConfig)

// Sync vue-router's current $route as part of vuex store's state
sync(store, router)

Vue.use(Vue2Filters)
Vue.use(VueCookie)
Vue.use(VueScrollTo, {
  container: 'body',
  duration: 1000,
  easing: 'ease'
})
Vue.use(Modal)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(UUID)

library.add(faTimesCircle, faPlusCircle, faAngleLeft, faAngleDown, faCheckCircle, faExclamationTriangle, faFont, faStream, faImages)

// RBI Components
Vue.component('nav-top', NavTop)
Vue.component('nav-bottom', NavBottom)
Vue.component('nav-mobile', NavMobile)
Vue.component('colors-select', ColorsSelect)
Vue.component('phrase', Phrase)
Vue.component('graphic', Graphic)
Vue.component('pricing', Pricing)
Vue.component('infinite-loading', InfiniteLoading)
Vue.component('order-row', OrderRow)
Vue.component('band-preview', BandPreview)
Vue.component('add-to-cart', AddToCart)
Vue.component('prev-step', PrevStep)
Vue.component('next-step', NextStep)
Vue.component('steps-bar', StepsBar)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('v-stepper-step-link', VStepperStepLink)
Vue.component('share-link', ShareLink)

let fixedPreview = new FixedPreview(store.state.customband)

/* eslint-disable no-new */
new Vue({
  data: {
    fixedPreview
  },
  store,
  router,
  render: h => h(App)
}).$mount('#app')

// new Vue({
//   el: '#app',
//   data: {
//     fixedPreview
//   },
//   store,
//   router,
//   template: '<App :fixedPreview="fixedPreview"/>',
//   components: { App },
//   computed: {
//     ...mapState([
//       // map this.customband to store.state.customband
//       'customband',
//       'customstates'
//     ])
//   },
//   created () {
//     // console.log('store.state.customband', store.state.customband)
//     // console.log('this', this)
//
//     let currentRouteName = router.currentRoute.name
//     let allStates = _get(store, 'state.customband.layout.manifest.states', null)
//     let currentRouteExists = allStates.find((ele) => {
//       return currentRouteName === ele.state
//     })
//
//     // Go to first state from manifest if the route requested doesn't exist in the manifest
//     let firstState = _get(store, 'state.customband.layout.manifest.states.0.state', null)
//     if (firstState && !currentRouteExists) {
//       router.replace({ name: firstState })
//     }
//   }
// })
